import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TreePalm } from "lucide-react";

const fmt = (iso) => { try { return new Date(iso + "T00:00:00").toLocaleDateString(undefined, { month: "short", day: "numeric" }); } catch { return iso; } };

export function useAwayMap() {
  const [map, setMap] = useState({});
  useEffect(() => { fetchAwayMap().then(setMap); }, []);
  return map;
}

let _awayCache = { at: 0, map: {} };
export async function fetchAwayMap(maxAgeMs = 60000) {
  if (Date.now() - _awayCache.at < maxAgeMs) return _awayCache.map;
  try {
    const { data } = await api.get("/ooo/directory");
    _awayCache = { at: Date.now(), map: data || {} };
  } catch (e) { console.error("away map", e); }
  return _awayCache.map;
}

export const awayFor = (map, email) => map[(email || "").trim().toLowerCase()];
export const fmtBack = (away) => fmt(away.back);

export function AwayBadge({ away, compact = false, className = "" }) {
  if (!away) return null;
  const isAway = away.status === "away";
  const text = isAway ? `Away · back ${fmt(away.back)}` : `Out ${fmt(away.start)} – ${fmt(away.end)}`;
  const title = [isAway ? `Out of office ${fmt(away.start)} – ${fmt(away.end)}` : `Scheduled out · back ${fmt(away.back)}`, away.note].filter(Boolean).join(" — ");
  return (
    <span title={title} data-testid={isAway ? "away-badge" : "upcoming-away-badge"}
      className={`inline-flex items-center gap-1 rounded-sm font-medium whitespace-nowrap ${compact ? "text-[10px] px-1.5 py-px" : "text-[11px] px-2 py-0.5"} ${isAway ? "bg-amber-100 text-amber-800" : "bg-secondary text-muted-foreground"} ${className}`}>
      <TreePalm className={compact ? "h-2.5 w-2.5" : "h-3 w-3"} />{text}
    </span>
  );
}

export function AwayNote({ away }) {
  if (!away) return null;
  const isAway = away.status === "away";
  return (
    <div className={`mt-3 text-xs border p-2.5 rounded-sm ${isAway ? "bg-amber-50 border-amber-200 text-amber-800" : "bg-secondary/60 border-border text-muted-foreground"}`} data-testid="away-note">
      <span className="font-semibold">{isAway ? "Out of office" : "Scheduled out"}</span> {fmt(away.start)} – {fmt(away.end)} · back {fmt(away.back)}{away.note && <span> — {away.note}</span>}
    </div>
  );
}
